/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// State
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

import {
	TMintHistoryModified,
	TMintHistoryQueryParams,
	TMintHistorySortParams,
} from '../types';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IMintHistorySlice {
	mintHistoriesPage: number;
	mintHistoriesTotal: number;
	mintHistoriesPageSize: number;
	mintHistoriesTotalPages: number;
	mintHistoriesQueryParams: any;
	mintHistoriesSortParams: any;
	mintHistorySelected: Partial<TMintHistoryModified>;
	setMintHistorySelected: (
		_mintHistory: Partial<TMintHistoryModified>
	) => void;
	setMintHistoriesPage: (
		_mintHistoriesPage: number
	) => void;
	setMintHistoriesQueryParams: (
		_mintHistoriesQueryParams: any
	) => void;
	setMintHistoriesSortParams: (
		_mintHistoriesSortParams: any
	) => void;
	setMintHistoriesPageSize: (_pageSize: any) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

const initialState = {
	mintHistoriesTotal: 0,
	mintHistoriesPage: 1,
	mintHistoriesPageSize: 10,
	mintHistoriesQueryParams: {},
	mintHistoriesSortParams: {},
	mintHistorySelected: {},
	mintHistoriesTotalPages: 0,
};

export const createMintHistorySlice: StateCreator<
	TStore,
	[],
	[],
	IMintHistorySlice
> = (set) => ({
	...initialState,
	setMintHistorySelected: (
		_mintHistory: Partial<TMintHistoryModified>
	) => set({ mintHistorySelected: _mintHistory }),
	setMintHistoriesPage: (_page: number) =>
		set({ mintHistoriesPage: _page }),
	setMintHistoriesPageSize: (_pageSize: number) =>
		set({ mintHistoriesPageSize: _pageSize }),
	setMintHistoriesTotalPages: (_totalPages: number) =>
		set({ mintHistoriesTotalPages: _totalPages }),
	setMintHistoriesSortParams: (
		_sortStatus: TMintHistorySortParams
	) => set({ mintHistoriesSortParams: _sortStatus }),
	setMintHistoriesQueryParams: (
		_queryParams: TMintHistoryQueryParams
	) => set({ mintHistoriesQueryParams: _queryParams }),
});
